
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  trackPageView,
  getFeatureFlag,
  isFeatureEnabled,
  FeatureFlags,
  analyticsEvents,
  trackEvent
} from "@/services/analytics";
import { useFeatureFlagStore } from "@/store/featureFlagStore";

export function useAnalytics() {
  const location = useLocation();
  const { refreshFlags, advancedInventoryTracking } = useFeatureFlagStore();

  // Track page views automatically when route changes
  useEffect(() => {
    const pageName = location.pathname;
    trackPageView(pageName, {
      url: window.location.href,
      path: pageName,
      search: location.search,
    });
    
    // Refresh feature flags on route change
    refreshFlags();
  }, [location, refreshFlags]);

  // Track feature usage
  const trackFeatureUsage = (featureName: string, properties?: Record<string, string>) => {
    trackEvent('feature_used', {
      feature: featureName,
      ...properties
    });
  };

  return {
    getFeatureFlag,
    isFeatureEnabled,
    trackEvent,
    trackPageView,
    analyticsEvents,
    trackFeatureUsage,
    featureFlags: {
      advancedInventoryTracking
    },
    refreshFlags
  };
}
